import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminLayout from './components/AdminLayout';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

// Public Pages
import Home from './pages/public/Home';
import About from './pages/public/About';
import Courses from './pages/public/Courses';
import Certifications from './pages/public/Certifications';
import Branches from './pages/public/Branches';
import Contact from './pages/public/Contact';
import ApplyOnline from './pages/public/ApplyOnline';
import PublicResult from './pages/public/PublicResult';
import OurProducts from './pages/public/OurProducts';

// Admin Pages
import Login from './pages/admin/Login';
import Dashboard from './pages/admin/Dashboard';
import Students from './pages/admin/Students';
import AdminCourses from './pages/admin/Courses';
import AdminBranches from './pages/admin/Branches';
import Subjects from './pages/admin/Subjects';
import Results from './pages/admin/Results';
import StudentResults from './pages/admin/StudentResults';
import Admissions from './pages/admin/Admissions';
import Products from './pages/admin/Products';

// Create theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <Routes>
            {/* Public Routes with Navbar/Footer */}
            <Route
              element={
                <>
                  <Navbar />
                  <div style={{ minHeight: 'calc(100vh - 64px - 200px)' }}>
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/about" element={<About />} />
                      <Route path="/courses" element={<Courses />} />
                      <Route path="/certifications" element={<Certifications />} />
                      <Route path="/branches" element={<Branches />} />
                      <Route path="/contact" element={<Contact />} />
                      <Route path="/apply/:courseId" element={<ApplyOnline />} />
                      <Route path="/verify-result" element={<PublicResult />} />
                      <Route path="/ourproducts" element={<OurProducts />} />
                    </Routes>
                  </div>
                  <Footer />
                  <WhatsAppButton />
                </>
              }
            >
              <Route path="*" element={<Navigate to="/" />} />
            </Route>

            {/* Login Route */}
            <Route path="/login" element={<Login />} />

            {/* Admin Routes */}
            <Route
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/admin/dashboard" element={<Dashboard />} />
              <Route path="/admin/students" element={<Students />} />
              <Route path="/admin/courses" element={<AdminCourses />} />
              <Route path="/admin/subjects" element={<Subjects />} />
              <Route path="/admin/branches" element={<AdminBranches />} />
              <Route path="/admin/results" element={<Results />} />
              <Route path="/admin/student-results" element={<StudentResults />} />
              <Route path="/admin/admissions" element={<Admissions />} />
              <Route path="/admin/products" element={<Products />} />
            </Route>

            {/* Catch all - redirect to home */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
